import React from 'react';
import PropTypes from 'prop-types';
import NavLink from 'components/nav/shared/NavLink';

import connectStore from 'decorators/connectStore';
import VerifiedProfileStore from 'stores/VerifiedProfileStore';
import VerifiedProfileActionCreator from 'actions/VerifiedProfileActionCreator';

@connectStore(VerifiedProfileStore, 'verifiedProfileState')
class PrimaryItems extends React.Component {
  static propTypes = {
    verifiedProfileState: PropTypes.shape({
      accountPool: PropTypes.shape({
        accountPoolName: PropTypes.string,
      }).isRequired,
    }),
  };

  componentDidMount() {
    VerifiedProfileActionCreator.fetchAccountPool();
  }

  render() {
    return (
      <ul className="nav navbar-nav">
        <li><NavLink to="/home" type="Link" stringID="AA_Home" /></li>
        <li><NavLink to="/profile" type="Link" stringID="AA_AuthorPage" /></li>
        <li><NavLink to="/books" type="Link" stringID="AA_Books" /></li>
        <li><NavLink to="/marketingAndReports" type="Link" stringID="AA_Marketing_Reports_Heading" /></li>
      </ul>
    );
  }
}

export default PrimaryItems;
